import { patchResource } from '@/api/apiResource.calls';

export async function updateFile(file, patch) {
  return Object.assign(file, await patchResource({ ...file, ...patch }));
}
